export enum ButtonStyledWidth {
  AUTO = "auto",
  FULL = "100%",
}
export interface ButtonStyledInterface {
  width?: string;
  $margin?: string;
}

export interface ButtonPropsInterface {
  name: string;
  styles?: ButtonStyledInterface;
  className?: string;
  disabled?: boolean;
  onClick?: (e?: any) => void;
  testid?: string;
  bgColor?:string;
}
